// const timeSummary = "/telecallers/timeSummary";
// const digimrCallHistories = "/telecallers/histories";
// const digimrProjectSumary = "/telecallers/project/summary";
// const digimrBestCallStatus = "/telecallers/best-call-status";
// const fieldMrReferralVerify = "/users/count";
// const fieldMrReferralSummary = '/users/referred-by-fieldmrs';
//
// export { timeSummary, digimrCallHistories, digimrProjectSumary, digimrBestCallStatus,fieldMrReferralVerify, fieldMrReferralSummary };

const loginUrl = "auth/login";

const categories_path = {
  SEARCH_CATEGORY: "search_categories",
  LIST_CATEGORY: "categories",
  SAVE_CATEGORY: "categories",
  DELETE_CATEGORY: "categories",
};

const BrandsPath = {
  BASIC_BRAND: "brands",
  BRAND_SEARCH: "brand_search",
  BRAND_KIT: "fetch_brand_kit",
  GET_BRANDS: "brands/getBrandList",
};

const BrandMenu = {
  BRAND_MENU: "brand_menu",
  BRAND_SEARCH_MENU: "brand_search_menu",
};

const Incentive = {
  GET_INCENTIVES: "staff/get_incentive",
  DOWNLOAD_INVCENTIVES: "staff/downloadInsentive",
  GENERATIVE_INCENTIVES: "staff/incentive_generate",
};

const StorePath = {
  STORE_SAVE: "stores",
  GET_STORES: "stores",
  GET_STORE: "get_store",
  SEARCH_STORE: "search_stores",
  DELETE_STORE: "stores",
  PUSH_TO_UP: "store_push_to_up",
  STORE_ITEM_TAG: "store_item_tag",
  STORE_TOGGLE_UP: "store_toggle",
};

const OpsPath = {
  GETOPGS: "option_groups",
  SEARCHOPGS: "search_opg",
  SAVEOPGS: "option_groups",
  PUSH_TO_UP: "opg_push_to_up",
  ITEM_TAG_OPG: "opg_item_tag",

  GETOPS: "options",
  SAVEOPS: "options",
  SEARCH_OPS: "search_op",
  ITEM_TAG_OP: "op_item_tag",
  OP_PUSH_TO_UP: "op_push_to_up",

  SAVEOPSGRAVY: "options_save_gravy",
  DELETEOPSGRAVY: "options_delete_gravy",

  SAVEOPSPACKAGING: "options_save_packaging",
  DELETEOPSPACKAGING: "options_delete_packaging",
};

const ChargesPath = {
  ALL: "charges",
  PUSH_TO_UP: "charges_push_to_up",
};

const RestaurantsPath = {
  BASIC_RESTAURENT: "restaurants",
  GET_RESTAURANTS: "get_restaurants",
  SAVE_BANK_INFO: "save_restaurant_bank_info",
  STATUS_TOGGLE: "restaurant_status",
  SAVE_TIMINGS: "restaurant_timings",
  GET_TIMINGS: "restaurant_timings",
  GET_ALL_RPS_PNL: "restaurants/get_restaurants_pnl",
  GET_RP_PNL: "restaurants/rp_pnl",
  SAVE_RP_PNL: "restaurants/save_rp_pnl",
  UPDATE_RP_PNL: "restaurants/update_rp_pnl/",
};

const AggregatorPath = {
  getAggregators: "aggregators",
};

const ItemPath = {
  ALL: "items",
  ATTACH_BRAND: "attach_item_brand",
  DELETE_IMAGE: "delete_item_image",
  ITEM_BRANDS: "item_brands",
  ITEM_OPTIONS: "item_options",
  ITEM_BRAND_OPTIONS: "item_brand_options",
  ITEM_BRAND_DETACH: "item_brand_remove",
  DUPLICATE_ITEM: "duplicate_item",
};

const MenuPath = {
  GetMenu: "menu",
  GetMenuItems: "menu_items",
  STORE_MENU: "menu",
  DELETE_MENU: "menu",
  STORE_ITEMS: "menu_items",
  DELETE_MENU_ITEMS: "delete_menu_items",
  SEARCH_ITEMS: "menu_search_items",
  GetItems: "get_items_without_menu",
  SAVE_BRAND_MENU: "attachBrandMenu",
  GET_BRAND_MENU: "menu_brands",

  MENU_LOCATIONS: "menu_locations",
  MENU_SEARCH: "search_menu",
  MENU_OPTIONS: "menu_options",
  MENU_PUSH_UP: "menu_push_up",
  MENU_ITEM_STOCK_OUT: "menu_stockOutItem",
};

const GravyPath = {
  ALL: "gravies",
  GRAVY_ORDER_LEVEL: "gravies_order_level",
  ATTACH_GRAVIES: "attach_gravy",
  GET_GRAVY_ITEMS: "gravy_items",
  GET_GRAVY_ITEMS_COMBINED: "gravy_items_combined",
  GET_ITEMS_OF_GRAVY: "items_gravy",
  DELETE_GRAVY_ITEMS: "delete_gravy_item",
  SEARCH_GRAVIES: "search_gravy",
  GRAVY_TRANSFER_TAGGING: "gravy_transfer_tagging",
  GRAVY_COPY_TAGGING: "gravy_copy_tagging",
  GRAVY_PROJECTION: "analytics/gravy_prediction",
  GRAVY_TRANSFER_PROJECTION: "analytics/gravy_transfer_projection",
  GRAVY_BRAND_SAVE: "add_gravy_brand",
  GRAVY_BRAND_REMOVE: "remove_gravy_brand",
  GRAVY_ORDER_AUTO_CREATION: "analytics/gravy_order_auto_creation",
  FETCH_GRAVY_WITH_BATCH: "fetch_gravy_with_batch",
  ORDERS: {
    GET: "gravy_orders",
    SEARCH: "search_gravy_orders",
    DELETE: "gravy_orders",
    SAVE: "gravy_orders",
    ORDER_ITEMS: "order_gravy_items",
    ACCEPT_ORDER: "gravy_accept_order",
    MARK_AS_SHIPPED: "gravy_mark_as_shipped",
    MARK_AS_DELIVERED: "gravy_mark_as_delivered",
    MARK_AS_PENDING: "gravy_mark_as_pending",
    GET_ORDER_RETURN: "get_gravy_order_returns",
    SAVE_ORDER_RETURN: "save_gravy_order_returns",
    RETURN_MARK_ACCEPT_COMPLETED: "gravy_order_return_mark_accept_completed",
    GRAVY_ORDER_INVOICE: "invoice_generate",
    GRAVY_ORDER_RETURN_INVOICE: "generate_return_invoice",
    SEARCH_BACHES: "search_batches",
    GET_RETURNS: "gravy_order_returns",
    SAVE_RETURNS: "gravy_order_return_save",
    UPDATE_RETURNS: "gravy_order_return_update",
    DELETE_RETURNS: "gravy_order_return_delete",
    GRAVY_RETURN_MARK_COMPLETE: "gravy_order_return_mark_complete",
    GRAVY_RETURN_MARK_ACCEPTED: "gravy_order_return_mark_accepted",
  },
};

const PaymentPath = {
  GET_ORDER_PAYMENT: "get_order_payment",
  ORDER_PAYMENT_CALLBACK: "order_payment_callback",
};

const PackagingPath = {
  ALL: "packaging",
  PACKAGING_ORDER_LEVEL: "packagings_order_level",
  ATTACH_PACKAGING: "attach_packaging",
  SEARCH_PACKAGING: "search_packaging",
  GET_PACKAGING_ITEMS: "packaging_items",
  GET_PACKAGING_ITEMS_COMBINED: "packaging_items_combined",
  DELETE_PACKAGING_ITEMS: "delete_packaging_item",
  PACKAGING_PROJECTION: "analytics/packaging_projection",
  PACKAGING_ORDER_AUTO_CREATION: "analytics/packaging_order_auto_creation",
  FETCH_PACKAGING_WITH_BATCH: "fetch_packaging_with_batch",
  PACKAGING_BRAND_SAVE: "packagings/saveBrand",
  PACKAGING_BRAND_REMOVE: "packagings/deleteBrand",
};

const PysicalInspectionPath = {
  SAVE_STOCK: "save_physical_stock",
  GET_INSPECTION_DATA: "get_physical_stock_data",
  GET_INSPECTION_ITEM_DATA: "physical_order_data",
  GETUPLOADEDFORMVALUES: "files/upload-excel",
  GETTODAYSTOCKINSPECTION: "stockinspection/todayinspection",
  GETSTOCKINSPECTIONFILEFORMAT: "stockinspection/stocketinspectionfileformat",
};

const ImagesPath = {
  UPLOAD_IMAGE: "upload_images",
  DELETE_IMAGE: "delete_images",
};

const OrdersPath = {
  GET_ORDERS: "up/orders",
  GET_ORDER_ITEMS: "up/order_items",
  SAVE_MISSING_ITEMS: "up/save_missing_items",
  SAVE_COMPLAINTS: "up/save_complaints",
};

const CityPath = {
  GET_CITY: "city_state",
};

const PayoutPath = {
  POST_POLICY: "upload_payouts",
};

const FunnelPath = {
  FUNNEL_IMPORT: "upload_funnel",
  ORDER_RATINGS_IMPORT: "upload_ratings",
  STOCKOUT_IMPORT: "upload_stock_out_report",
  STOCKOUT_REPORTS: "fetch_stock_out_reports",
  STOCKOUT_GENERATE: "generate_stock_out_report",
  Warehouse_Inspection_Import: "warehouse_insepction_import",
  Warehouse_Inspection_EXPORT: "warehouse_insepction_export",
};

const RhiPath = {
  RHI_IMPORT: "upload_rhi",
};

const ComplaintsPath = {
  COMPLAINTS_IMPORT: "upload_complaints",
};

const LocationPath = {
  Locations: "warehouse/locations",
  LOCATION_SEARCH: "warehouse/search_location",
};

const WarehousePath = {
  ADD: "warehouse/add",
  Warehouses: "warehouse/warehouses",
  WAREHOUSE_SEARCH: "warehouse/search_warehouse",
  WarehouseStockProjection: "warehouse/projection",
};

const WareHouseStock = {
  GET_LIST: "warehouse/inspection/list",
  SAVE_LIST: "warehouse/inspection/save",
  MOVE_TO_INSPECTED: "warehouse/inspection/confirm_inspection",
  GENERATE_REPORT: "warehouse/inspection/generateReport",
};

const InboundOrderPath = {
  SaveOrder: "inbound_orders/save",
  UpdateOrder: "inbound_orders/update",
  UpdateStatus: "inbound_orders/update_status",
  GET_ORDERS: "inbound_orders/list",
  DELETE_ORDER: "inbound_orders/delete",
  DELETE_BATCH_CODE: "inbound_orders/delete_batch_code",
  ORDER_GRAVIES_PACKAGING: "inbound_orders/orderGraviesOrPackaging",
  GET_STOCK_DETAILS: "inbound_orders/stock_details",
  GET_BATCH_LEVEL_STOCK: "inbound_orders/batch_level_stock",
  SEARCH_BATCHES: "inbound_orders/search_batches",
  TRANSFER_BATCHES: "inbound_orders/transfer_batches",
  SAVE_TRANSFER_BATCH: "inbound_orders/save_transfer_batch",
  GET_BATCH_LEVEL_STOCK_SELECTED: "inbound_orders/batch_level_stock_selected",
  INBOUND_ORDER_INVOICE: "inbound_orders/inbound_invoice_generate",
  PROJECTION: "inbound_orders/projection",
  GET_BATCH_DETAILS: "inbound_orders/get_batch_details",
  SAVE_TRANSFER_BATCH_V2: "inbound_orders/v2/save_transfer",
  EDIT_TRANSFER_BATCH_V2: "inbound_orders/v2/edit_save_transfer",
  REMOVE_TRANSFER_ITEM: "inbound_orders/v2/remove_item_from_transfer",
  GENERATE_BARCODES: "inbound_orders/v2/generate_barcodes",
};

const USERSPATH = {
  GET_ACCOUNTMANAGET_USERS: "users",
  GET_PERMISSIOINS: "permissions",
  GET_ROLES: "roles",
  SAVE_USER: "create_user",
  SYNC_PERMISSIONS: "sync_permissions",
  DELETE_USER: "delete_user",
};

const RAW_MATERIAL_PATH = {
  SEARCH_ITEMS: "raw_mateirals/search",
  LIST: "raw_mateirals",
  DEACTIVATE: "raw_mateirals/deactivate",
  SAVE: "raw_mateirals",
  SAVE_ORDER: "raw_mateirals/save_order",
  GET_ORDERS: "raw_mateirals/get_orders",
  MARK_AS_RECEIVED: "raw_mateirals/mark_as_received",
  DELETE_ORDER: "raw_mateirals/delete_order",
  DELETE: "raw_mateirals/delete",
  GET_ORDER_ITEMS: "raw_mateirals/get_order_items",
  ADD_PRICE: "raw_mateirals/add_price",
  DOWNLOAD_PO: "raw_mateirals/download_po",
};

const RG_RECIPE_PATH = {
  GET: "recipe/",
  SHOW: "recipe/show",
  SEARCH: "recipe/rg_search",
  SAVE: "recipe/save",
  UPDATE: "recipe/update",
  DELETE: "recipe/delete",
  LIST_RECIPE_CARD: "recipe/list_recipe_card",
  SAVE_RECIPE_CARD: "recipe/recipe_card_save",
  DELETE_RECIPE_CARD: "recipe/recipe_card_delete",
};

const VENDORS_PATH = {
  GET: "vendor",
  SAVE: "vendor/store",
  SHOW: "vendor/show",
  UPDATE: "vendor/update",
  DELETE: "vendor/destroy",
  GET_BANK_DETAILS: "vendor/bank_details",
  SAVE_BANK_DETAILS: "vendor/save_bank_details",
  GET_VENDOR_RAW_MATERIALS: "vendor/raw_materials",
  ATTACH_VENDOR_RAW_MATERIALS: "vendor/attach_raw_materials",
};

const TicketsPath = {
  // GET_PAYOUT_LINK : 'tickets/get_payout_link',
  SAVE_TICKET: "tickets/save_ticket",
  GET_TICKETS: "tickets/get_tickets",
  GET_ASSINGEES: "tickets/get_category_assignees",
  SAVE_ASSIGNEES: "tickets/save_category_assignees",
  DELETE_ASSIGNEES: "tickets/delete_category_assignees",
  UPDATE_TICKET_STATUS: "tickets/update_ticket_status",
  UPDATE_TICKET_PRIORITY: "tickets/update_ticket_priority",
  UPDATE_TICKET_TAT: "tickets/change_tat",
  ASSIGN_TICKET_TO_USER: "tickets/assign_ticket_to_user",
  SEARCH_USERS: "tickets/search_users",
  FETCH_ORDERS: "tickets/fetch_orders",
  FETCH_GRAVIES: "tickets/fetch_gravies",
  FETCH_PACKAGING: "tickets/fetch_packaging",
  FETCH_BANK_INFO: "tickets/fetch_bank_info",
  FETCH_TIMINGS: "tickets/fetch_timings",
};

const RP_PRICES = {
  GET_ITEM_PRICES: "item_rp_prices",
  GET_OPTION_PRICES: "option_rp_prices",
  POST_OPTION_PICES: "option_rp_prices",
  POST_ITEM_PRICES: "item_rp_prices",
  DELETE_ITEM_PRICES: "delete_item_rp_price",
  DELETE_OPTION_PRICES: "delete_option_rp_price",
};

const NODE_AUTH = {
  GET_TOKEN: "auth/generate-token",
};

const DASHBOARD_PATH = {
  RATING: "dashboard/rating",
  ORDERS: "dashboard/orders",
  REVENUE: "dashboard/revenue",
  VISIBILITY: "dashboard/visibility",
  CANCELLATIONS: "dashboard/cancellations",
  COMPLAINTS: "dashboard/complaints",
  KPT: "dashboard/kpt",
  REPEAT_CUSTOMERS: "dashboard/repeatcustomers",
  OUT_OF_STOCK: "dashboard/outofstock",
  ORDERS_GRAPH: "dashboard/orders/graph",
  REVENUE_GRAPH: "dashboard/revenue/graph",
  VISIBILITY_GRAPH: "dashboard/visibility/graph",
  CANCELLATIONS_GRAPH: "dashboard/cancellations/graph",
  COMPLAINTS_GRAPH: "dashboard/complaints/graph",
  KPT_GRAPH: "dashboard/kpt/graph",
  OUTOFSTOCK_GRAPH: "dashboard/outofstock/graph",
};

const BUSSINESS_REPORT_PATH = {
  GET_OSS_REPORT: "fetch_oss_reports",
  POST_OSS_REPORT: "upload_oss_report",
};

const ChunkUploadPath = {
  CHUNK_UPLOAD: "chunk_uploads",
};

export {
  NODE_AUTH,
  RP_PRICES,
  DASHBOARD_PATH,
  TicketsPath,
  RG_RECIPE_PATH,
  InboundOrderPath,
  WarehousePath,
  LocationPath,
  RAW_MATERIAL_PATH,
  USERSPATH,
  PysicalInspectionPath,
  ComplaintsPath,
  RhiPath,
  FunnelPath,
  PayoutPath,
  CityPath,
  OrdersPath,
  PackagingPath,
  GravyPath,
  BrandMenu,
  MenuPath,
  loginUrl,
  categories_path,
  BrandsPath,
  RestaurantsPath,
  StorePath,
  AggregatorPath,
  OpsPath,
  ChargesPath,
  ItemPath,
  ImagesPath,
  PaymentPath,
  VENDORS_PATH,
  Incentive,
  WareHouseStock,
  BUSSINESS_REPORT_PATH,
  ChunkUploadPath,
};
